import { css, SerializedStyles } from '@emotion/react'
import { HFlow, Theme, useTheme } from 'bold-ui'
import { orange } from 'bold-ui/lib/styles/colors'
import { ClassificacaoVulnerabilidadeFamiliar, GrauSugestivoVulnerabilidadeFamiliar } from 'graphql/types.generated'
import {
  classificacaoVulnerabilidadeRecord,
  grauSugestivoRecord,
} from 'view/atendimentos/detail/prontuario-familiar/model-prontuarioFamiliar'

interface VulnerabilidadeFamiliarStatusProps {
  classificacao: ClassificacaoVulnerabilidadeFamiliar
  escore?: number | null
  grauSugestivo?: GrauSugestivoVulnerabilidadeFamiliar | null
}

export const VulnerabilidadeFamiliarStatus = ({
  classificacao,
  escore,
  grauSugestivo,
}: Readonly<VulnerabilidadeFamiliarStatusProps>) => {
  const theme = useTheme()
  const styles = createStyles(theme)

  const classificacaoBoxStyle: SerializedStyles = {
    [ClassificacaoVulnerabilidadeFamiliar.HABITUAL]: styles.statusBoxHabitual,
    [ClassificacaoVulnerabilidadeFamiliar.SUGESTIVA]: styles.statusBoxSugestiva,
    [ClassificacaoVulnerabilidadeFamiliar.INEQUIVOCA]: styles.statusBoxInequivoca,
  }[classificacao]

  const classificacaoText = classificacaoVulnerabilidadeRecord[classificacao]
  const escoreText = `(${escore ?? 0} ponto${escore === 1 ? '' : 's'})`
  const grauSugestivoText =
    grauSugestivo && ` | Escala Coelho-Savassi - ${grauSugestivoRecord[grauSugestivo]} ${escoreText}`

  return (
    <HFlow hSpacing={0.5} alignItems='center'>
      <span css={classificacaoBoxStyle} />
      {classificacaoText}
      {grauSugestivoText}
    </HFlow>
  )
}

const baseStatusBox = css`
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border-radius: 0.2rem;
`

const createStyles = (theme: Theme) => ({
  statusBoxHabitual: css`
    ${baseStatusBox};
    background-color: ${theme.pallete.status.success.main};
  `,
  statusBoxSugestiva: css`
    ${baseStatusBox};
    background-color: ${orange.c60};
  `,
  statusBoxInequivoca: css`
    ${baseStatusBox};
    background-color: ${theme.pallete.status.danger.main};
  `,
})
